import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getStationPayDistributionCounter } from '@/api/bairun/financialCenter';
import NP from 'number-precision';
import { mapGetters } from 'vuex';
export default {
  name: 'SlotCounterStationPayDistributionSheet',
  components: {},
  props: {
    start: {
      type: Number,
      required: true
    },
    end: {
      type: Number,
      required: true
    },
    totalId: {
      type: Number,
      default: 999
    },
    refIndex: {
      type: Number,
      required: true
    },
    sheetType: {
      type: String,
      required: true
    },
    slotCounterName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      switchValue: false,
      loading: false,
      slotOption: '',
      selectedOilCode: '92',
      selectedArea: '全部',
      dayNums: 0,
      monthNums: 0,
      daySumSvcNums: 0,
      daySumUserNums: 0,
      monthSumSvcNums: 0,
      monthSumUserNums: 0,
      groupData: [],
      renderData: [],
      borderFix: ['合计/L', '合/L', '0#'],
      cellColClassFix: ['monthSumUserNums', 'monthGoodsPrice', 'monthAvgUserPrice', 'monthDiffUserPrice', 'monthSumSvcNums', 'monthAvgSvcPrice', 'monthDiffSvcPrice'],
      filterMapping: [{
        text: '佛山',
        value: '佛山'
      }, {
        text: '粤西',
        value: '粤西'
      }, {
        text: '外省',
        value: '外省'
      }],
      showStations: [],
      customColors: [{
        color: '#909399',
        percentage: 30
      }, {
        color: '#f56c6c',
        percentage: 60
      }, {
        color: '#e6a23c',
        percentage: 85
      }, {
        color: '#409eff',
        percentage: 99
      }, {
        color: '#67c23a',
        percentage: 100
      }]
    };
  },
  watch: {
    end: function end() {
      this.loadMemberDiscountData();
    },
    refIndex: function refIndex() {
      this.refIndexRefresh();
    }
  },
  computed: _objectSpread({}, mapGetters('stations', ['asyncStations'])),
  created: function created() {
    this.loadMemberDiscountData();
  },
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {
      _this.$refs['tableStationPayDistribution' + _this.sheetType].doLayout();
    });
  },
  methods: {
    refIndexRefresh: function refIndexRefresh() {
      this.$refs['tableStationPayDistribution' + this.sheetType].doLayout();
    },
    npPlus: function npPlus() {
      var res = 0;

      for (var i in arguments) {
        res = NP.plus(res, arguments[i]);
      }

      return res;
    },
    percentShow: function percentShow(a, b) {
      if (b === 0) return '0%';
      return NP.round(NP.times(NP.divide(Number(a), Number(b)), 100), 2) + '%';
    },
    filterHandler: function filterHandler(value, row, column) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i]['ID'] === row['stationId'] && this.asyncStations[i]['statArea'] === value) {
          return true;
        }
      }

      return false;
    },
    filterChange: function filterChange(selected) {
      this.selectedArea = selected['area'] && selected['area'][0] ? selected['area'][0] : '全部';
    },
    percentFormat: function percentFormat(value1, value2) {
      return value2 === 0 ? '--' : NP.round(NP.divide(value1, value2) * 100, 2) + '%';
    },
    numsFormat: function numsFormat(value) {
      return NP.round(NP.divide(value, 10000), 2);
    },
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
          column = _ref.column;

      if (this.borderFix.includes(column.label)) {
        return 'border-right:1px solid #000000';
      }

      if (this.cellColClassFix.includes(column.property)) {
        return 'background: #ffe9cf';
      }
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return NP.plus(prev, curr);
            } else {
              return prev;
            }
          }, 0);
          sums[index] = NP.round(sums[index], 2);
        } else {
          sums[index] = 'N/A';
        }
      });

      if (this.switchValue) {
        sums[2] = sums[1] > 0 ? this.percentShow(sums[2], sums[1]) : '-';
        sums[3] = sums[1] > 0 ? this.percentShow(sums[3], sums[1]) : '-';
        sums[4] = sums[1] > 0 ? this.percentShow(sums[4], sums[1]) : '-';
        sums[5] = sums[1] > 0 ? this.percentShow(sums[5], sums[1]) : '-';
        sums[6] = sums[1] > 0 ? this.percentShow(sums[6], sums[1]) : '-';
        sums[7] = sums[1] > 0 ? this.percentShow(sums[7], sums[1]) : '-';
        sums[8] = sums[1] > 0 ? this.percentShow(sums[8], sums[1]) : '-';
        sums[9] = sums[1] > 0 ? this.percentShow(sums[9], sums[1]) : '-';
        sums[10] = sums[1] > 0 ? this.percentShow(sums[10], sums[1]) : '-';
        sums[11] = sums[1] > 0 ? this.percentShow(sums[11], sums[1]) : '-';
        sums[12] = sums[1] > 0 ? this.percentShow(sums[12], sums[1]) : '-';
        sums[13] = sums[1] > 0 ? this.percentShow(sums[13], sums[1]) : '-';
        sums[14] = sums[1] > 0 ? this.percentShow(sums[14], sums[1]) : '-';
        sums[15] = sums[1] > 0 ? this.percentShow(sums[15], sums[1]) : '-';
        sums[16] = sums[1] > 0 ? this.percentShow(sums[16], sums[1]) : '-';
        sums[17] = sums[1] > 0 ? this.percentShow(sums[17], sums[1]) : '-';
        sums[1] = sums[1] > 0 ? this.percentShow(sums[1], sums[1]) : '-';
      }

      return sums;
    },
    sellerName: function sellerName(sellerId) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i].ID === sellerId) {
          return this.asyncStations[i]['statAbbr'];
        }
      }

      return '';
    },
    loadMemberDiscountData: function loadMemberDiscountData() {
      var _this2 = this;

      if (this.loading) {
        return;
      }

      this.loading = true;
      var descriptorData = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          t: parseInt(this.sheetType),
          name: this.slotCounterName,
          start: this.start / 1000,
          end: this.end / 1000,
          search: this.totalId === 999 ? '' : this.totalId.toString()
        }]
      };
      getStationPayDistributionCounter(descriptorData).then(function (response) {
        var tempGroupData = Object.values(response.data);
        _this2.groupData = tempGroupData.sort(function (a, b) {
          var orders = [10006, 10003, 10011, 10013, 10010, 10014, 10001, 10012, 10002, 10005, 10004, 10009, 10008, 10015]; // // console.log('sort orders', orders.indexOf(a.sellerId), orders.indexOf(b.sellerId))

          return orders.indexOf(a.stationId) - orders.indexOf(b.stationId);
        });
        _this2.loading = false;
        _this2.renderData = _this2.groupDataFilter();

        _this2.$refs['tableStationPayDistribution' + _this2.sheetType].doLayout();
      }).catch(function () {
        _this2.loading = false;
      });
    },
    groupDataFilter: function groupDataFilter() {
      var renderArr = [];
      this.groupData.forEach(function (el) {
        var rendEl = {
          stationId: el.stationId,
          svcNums: 0,
          userNums: 0,
          platTotalNums: 0,
          plat1008Nums: 0,
          plat2001Nums: 0,
          plat2002Nums: 0,
          plat2003Nums: 0,
          plat2004Nums: 0,
          plat2005Nums: 0,
          plat2006Nums: 0,
          plat2007Nums: 0,
          plat2008Nums: 0,
          plat2009Nums: 0,
          plat2010Nums: 0,
          plat2011Nums: 0,
          plat2012Nums: 0,
          plat2013Nums: 0,
          plat2014Nums: 0,
          otherNums: 0,
          totalNums: 0
        };

        if (el.dailyGoodsData.length > 0) {
          el.dailyGoodsData.forEach(function (gd) {
            rendEl.svcNums = NP.plus(gd.sumSvcNums, rendEl.svcNums);
            rendEl.userNums = NP.plus(gd.sumUserNums, rendEl.userNums);
            rendEl.totalNums = NP.plus(gd.goodsNums, rendEl.totalNums);
          });
        }

        if (el.dailyPayWayData.length > 0) {
          el.dailyPayWayData.forEach(function (pd) {
            if (pd.payWay === 1008 || pd.payWay > 2000 && pd.payWay < 3000) {
              rendEl['plat' + pd.payWay + 'Nums'] = pd.stationOilMass;
              rendEl.platTotalNums = NP.plus(pd.stationOilMass, rendEl.platTotalNums);
            }
          });
        }

        rendEl.otherNums = NP.minus(rendEl.totalNums, rendEl.platTotalNums, rendEl.svcNums, rendEl.userNums);
        renderArr.push(rendEl);
      });
      return renderArr;
    }
  }
};